'use client';
import { QueryClientProvider as ReactQueryClientProvider } from '@tanstack/react-query';
import { getQueryClient } from './get-query-client';

export function QueryClientProvider({ children }: { children: React.ReactNode }) {
  const queryClient = getQueryClient();
  return <ReactQueryClientProvider client={queryClient}>{children}</ReactQueryClientProvider>;
}
